export interface Standort {
  slug: string;
  city: string;
  postalRange: string;
  distanceKm: number;
  intro: string;
  highlights: string[];
  districts?: string[];
}

export const standorte: Standort[] = [
  {
    slug: "herford",
    city: "Herford",
    postalRange: "32049 – 32052",
    distanceKm: 0,
    intro:
      "Unser Stammsitz: Von der Mindener Straße aus betreuen wir seit über 10 Jahren Eigenheime, Mehrfamilienhäuser und Gewerbeobjekte in ganz Herford – von der Altstadt bis nach Schwarzenmoor, Stedefreund und Diebrock.",
    highlights: [
      "Fassadendämmung & WDVS an Altbauten in der Innenstadt",
      "Schimmelsanierung in Mietwohnungen und WEG-Objekten",
      "Edle Oberflächen in Praxen, Kanzleien und Privathäusern",
    ],
    districts: ["Innenstadt", "Schwarzenmoor", "Stedefreund", "Diebrock", "Elverdissen", "Eickum"],
  },
  {
    slug: "bielefeld",
    city: "Bielefeld",
    postalRange: "33602 – 33739",
    distanceKm: 18,
    intro:
      "In Bielefeld realisieren wir energetische Fassadensanierungen, Innendämmung und exklusive Oberflächen – vom Gründerzeit-Altbau in Mitte bis zur modernen Stadtvilla in Sieker oder Brackwede.",
    highlights: [
      "Energetische Sanierung im Bielefelder Altbau-Bestand",
      "Schimmelschutz mit Calciumsilikat & HECK INNEO",
      "Marmorino & Betonoptik für Wohnen und Gastronomie",
    ],
    districts: ["Mitte", "Sieker", "Brackwede", "Schildesche", "Heepen", "Stieghorst"],
  },
  {
    slug: "bad-salzuflen",
    city: "Bad Salzuflen",
    postalRange: "32105 – 32108",
    distanceKm: 15,
    intro:
      "Im Kurort Bad Salzuflen arbeiten wir an Fachwerk, Gründerzeitfassaden und modernen Wohnhäusern – mit besonderem Fokus auf diffusionsoffene Systeme, die zum sensiblen Bestand passen.",
    highlights: [
      "Fassadensanierung an denkmalgeschützten Gebäuden",
      "Innendämmung wo Außendämmung nicht erlaubt ist",
      "Hochwertige Innengestaltung für Praxen & Hotellerie",
    ],
    districts: ["Innenstadt", "Schötmar", "Werl-Aspe", "Wülfer-Bexten"],
  },
  {
    slug: "loehne",
    city: "Löhne",
    postalRange: "32584",
    distanceKm: 10,
    intro:
      "Löhne ist Nachbarstadt – wir sind in Gohfeld, Mennighüffen und Obernbeck regelmäßig auf Baustellen. Schwerpunkt: energetische Fassadensanierung an Ein- und Zweifamilienhäusern.",
    highlights: [
      "WDVS-Fassadendämmung an Bestandsgebäuden",
      "Innensanierung nach Wasserschäden",
      "Schimmelschutz in Souterrain- und Kellerräumen",
    ],
    districts: ["Gohfeld", "Mennighüffen", "Obernbeck", "Bahnhof", "Löhne-Ort"],
  },
  {
    slug: "buende",
    city: "Bünde",
    postalRange: "32257",
    distanceKm: 16,
    intro:
      "In Bünde sanieren wir Fassaden, Bäder und Innenräume in allen Stadtteilen – vom typischen Klinker-Reihenhaus bis zur freistehenden Villa.",
    highlights: [
      "Fassadendämmung & WDVS für Energieeinsparung",
      "Fugenlose Bäder ohne Fliesen",
      "Komplette Innensanierung aus einer Hand",
    ],
    districts: ["Mitte", "Ennigloh", "Spradow", "Hunnebrock", "Holsen"],
  },
  {
    slug: "hiddenhausen",
    city: "Hiddenhausen",
    postalRange: "32120",
    distanceKm: 7,
    intro:
      "Direkt vor unserer Haustür: In Hiddenhausen, Schweicheln-Bermbeck und Sundern sind wir der schnelle Ansprechpartner für Maler-, Dämm- und Sanierungsarbeiten.",
    highlights: [
      "Kurze Anfahrtswege – schnelle Termine",
      "Fassadenanstrich und WDVS-Modernisierung",
      "Schimmelsanierung an Außenwänden im Bestand",
    ],
    districts: ["Hiddenhausen", "Schweicheln-Bermbeck", "Sundern", "Eilshausen", "Lippinghausen"],
  },
  {
    slug: "vlotho",
    city: "Vlotho",
    postalRange: "32602",
    distanceKm: 18,
    intro:
      "An der Weser betreuen wir Privatkunden in Vlotho, Exter und Valdorf – von der klassischen Fassadenrenovierung bis zur Komplettsanierung von Altbauten.",
    highlights: [
      "Fassadensanierung in Hanglage",
      "Innendämmung für ungedämmte Altbauten",
      "Edle Wandgestaltung & Spachteltechniken",
    ],
    districts: ["Vlotho", "Exter", "Valdorf", "Uffeln"],
  },
  {
    slug: "enger",
    city: "Enger",
    postalRange: "32130",
    distanceKm: 12,
    intro:
      "In Enger und Belke-Steinbeck setzen wir Sanierungsprojekte an Wohnhäusern und kleineren Gewerbeobjekten um – mit Fokus auf saubere Ausführung und Termintreue.",
    highlights: [
      "Komplette Fassaden-Modernisierung",
      "Innenanstrich, Tapeten, Spachteltechniken",
      "Beratung zu Förderungen (BAFA/KfW)",
    ],
    districts: ["Enger", "Belke-Steinbeck", "Westerenger", "Pödinghausen"],
  },
  {
    slug: "kirchlengern",
    city: "Kirchlengern",
    postalRange: "32278",
    distanceKm: 13,
    intro:
      "Maler- und Sanierungsarbeiten in Kirchlengern, Häver und Quernheim – persönlich betreut, vom Erstgespräch bis zur Abnahme.",
    highlights: [
      "WDVS und klassische Putzfassaden",
      "Wohnraum-Renovierung schlüsselfertig",
      "Schimmelsanierung und Innendämmung",
    ],
    districts: ["Kirchlengern", "Häver", "Quernheim", "Stift Quernheim", "Südlengern"],
  },
  {
    slug: "spenge",
    city: "Spenge",
    postalRange: "32139",
    distanceKm: 17,
    intro:
      "Spenge, Hücker-Aschen, Lenzinghausen: Wir bringen Fassaden, Wohn- und Geschäftsräume optisch und energetisch auf den aktuellen Stand.",
    highlights: [
      "Fassadenanstrich & WDVS",
      "Edle Oberflächen für Wohn- und Geschäftsräume",
      "Komplettsanierungen mit fester Bauleitung",
    ],
    districts: ["Spenge", "Bardüttingdorf", "Hücker-Aschen", "Lenzinghausen", "Wallenbrück"],
  },
  {
    slug: "lemgo",
    city: "Lemgo",
    postalRange: "32657",
    distanceKm: 22,
    intro:
      "Die Alte Hansestadt Lemgo verlangt Erfahrung mit historischer Bausubstanz: Wir arbeiten hier mit diffusionsoffenen Systemen, mineralischen Putzen und sensibler Farbgestaltung.",
    highlights: [
      "Fachwerk- und Altbausanierung",
      "Innendämmung wo WDVS nicht zulässig ist",
      "Mineralische Putze & Kalkfarben",
    ],
    districts: ["Innenstadt", "Brake", "Lieme", "Hörstmar", "Entrup"],
  },
  {
    slug: "detmold",
    city: "Detmold",
    postalRange: "32756 – 32760",
    distanceKm: 28,
    intro:
      "In Detmold realisieren wir anspruchsvolle Sanierungsprojekte an Stadtvillen, Bestandsbauten und Gewerbeobjekten – inklusive energetischer Komplett-Konzepte.",
    highlights: [
      "Energetische Fassadensanierung & WDVS",
      "Hochwertige Innenraumgestaltung",
      "Schimmelschutz mit Calciumsilikat & HECK INNEO",
    ],
    districts: ["Innenstadt", "Hiddesen", "Pivitsheide", "Heidenoldendorf", "Berlebeck"],
  },
];
